<template>
  <TimeslotDashboardLayout>
    <div class="main-content booking class-page">
      <div>
        <div class="content-div">
          <div class="my-class-div">
            <h1 class="tab-heading">My Classes</h1>
            <div
              data-w-id="020d2082-0ee4-52e8-26fa-9fc9511d1521"
              @click="openClassModal"
              style="font-size: 14px;"
              class="button w-button"
            >
              + Create a class
            </div>
          </div>
          <div class="text-block-37" style="margin-top: 20px;">
            These are the classes registered by your students. All class times
            are based on your selected time zone
            <span class="text-span-2"
              ><strong>{{ customerInfo.customerTimezone }}</strong></span
            >.To update
            <span class="link-6 click-margin" @click="openTime">
              <strong>Click Here</strong>
            </span>
          </div>
        </div>
      </div>
      <BaseComponentLoader
        v-if="loader.nonBlockingLoader"
        loaderAlignment="center"
      />
      <div v-else>
        <div
          style="display: flex; justify-content: flex-end;"
          v-if="userClassesAlt.length !== 0"
        >
          <div class="filter-size">
            <FormulateInput
              type="select"
              name="bookingStatus"
              placeholder="All"
              style="color: black;"
              :options="['All', 'Client', 'Personal']"
              v-model="filterType"
            />
          </div>
        </div>
        <!--        <div data-hover="false" data-delay="0" class="filter-wrapper-6 w-dropdown">-->
        <!--          <div class="filter w-dropdown-toggle">-->
        <!--            <div class="w-icon-dropdown-toggle"></div>-->
        <!--            <div>All</div>-->
        <!--          </div>-->
        <!--          <nav class="dropdown-list-2 w-dropdown-list">-->
        <!--            <a href="#" class="dropdown-link-3 w-dropdown-link">Client</a>-->
        <!--            <a href="#" class="dropdown-link-4 w-dropdown-link">Personal</a>-->
        <!--          </nav>-->
        <!--        </div>-->
        <div class="myclass-empty-state" v-if="userClassesAlt.length === 0">
          <div class="div-block-19">
            <img
              src="@/assets/timeslot-images/myclass.svg"
              loading="lazy"
              alt=""
              class="image-6"
            />
            <div class="text-block-20">Nothing to show here</div>
            <div class="text-block-21">
              You do not have any class created yet
            </div>
          </div>
        </div>
        <div
          v-else
          data-current="Tab 1"
          data-easing="ease"
          data-duration-in="300"
          data-duration-out="100"
          class="tabs w-tabs"
          style="margin-top:0;"
        >
          <div class="tabs-menu-2 w-tab-menu">
            <a
              data-w-tab="Tab 2"
              :class="
                upcoming
                  ? 'booking-tab w-inline-block w-tab-link w--current'
                  : 'booking-tab w-inline-block w-tab-link'
              "
              @click="openUpcoming"
            >
              <div>Upcoming</div>
            </a>
            <a
              data-w-tab="Tab 3"
              :class="
                past
                  ? 'booking-tab w-inline-block w-tab-link w--current'
                  : 'booking-tab w-inline-block w-tab-link'
              "
              @click="openPast"
            >
              <div>Past</div>
            </a>
          </div>
          <div class="w-tab-content">
            <div
              data-w-tab="Tab 2"
              v-if="upcoming"
              :class="upcoming ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
            >
              <div
                class="myclass-empty-state"
                v-if="upcomingClasses.length === 0"
              >
                <div class="div-block-19">
                  <img
                    src="@/assets/timeslot-images/myclass.svg"
                    loading="lazy"
                    alt=""
                    class="image-6"
                  />
                  <div class="text-block-20">Nothing to show here</div>
                  <div class="text-block-21">
                    You do not have any upcoming class
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  class="bookings-list-wrapper bookings"
                  v-for="(singleClass, index) in upcomingClasses"
                  :key="index"
                >
                  <div class="div-block-24-copy">
                    <div class="booking-heading">
                      <div
                        class="text-block-24"
                        @click="goToClassDetails(singleClass)"
                        style="cursor:pointer;"
                      >
                        {{ singleClass.groupSessionTopic }}
                      </div>
                    </div>
                    <div class="div-block-22">
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/calendar.svg"
                          alt=""
                          class="image-7"
                        />
                        <div>
                          {{
                            new Date(
                              singleClass.groupSessionStartTime.slice(0, 10)
                            )
                              .toString()
                              .slice(0, 11)
                          }}
                        </div>
                      </div>
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/calendar.svg"
                          alt=""
                          class="image-8"
                        />
                        <div>
                          {{
                            formatHours(
                              new Date(singleClass.groupSessionStartTime)
                            )
                          }}:{{
                            formatMinutes(
                              new Date(singleClass.groupSessionStartTime)
                            )
                          }}
                          {{
                            formatTime(
                              new Date(singleClass.groupSessionStartTime)
                            )
                          }}
                          -
                          {{
                            formatHours(
                              new Date(singleClass.groupSessionEndTime)
                            )
                          }}:{{
                            formatMinutes(
                              new Date(singleClass.groupSessionEndTime)
                            )
                          }}
                          {{
                            formatTime(
                              new Date(singleClass.groupSessionEndTime)
                            )
                          }}
                        </div>
                      </div>
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/money.svg"
                          alt=""
                          class="image-9"
                        />
                        <div>${{ singleClass.groupSessionAmount }}</div>
                      </div>
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/Frame.svg"
                          alt=""
                          class="image-9"
                        />
                        <div>
                          {{ singleClass.groupSessionMaxAttendance }} learners
                        </div>
                      </div>
                    </div>
                    <div
                      class="div-block-25 margin-booking"
                      v-if="upcomingOpen && isSelected === index"
                    >
                      <div class="professional-detail-wrapper">
                        <div class="professional-name-wraper">
                          <div class="text-block-25">
                            No of students currently registered:
                          </div>
                          <div class="div-block-26">
                            <!--                          <div>-->
                            <!--                            <img-->
                            <!--                                width="45"-->
                            <!--                                loading="lazy"-->
                            <!--                                :src="-->
                            <!--                             require('@/assets/timeslot-images/profileImg.svg')-->
                            <!--                              "-->
                            <!--                                alt=""-->
                            <!--                                class="image-10"-->
                            <!--                            />-->
                            <!--                          </div>-->
                            <div>
                              <div
                                class="text-block-26"
                                @click="goToClassDetails(singleClass)"
                                style="cursor:pointer;"
                              >
                                {{ singleClass.groupSessionCurrentAttendees }}
                                student<span
                                  v-if="
                                    singleClass.groupSessionCurrentAttendees > 1
                                  "
                                  >s</span
                                >
                              </div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                        <div class="professional-name-wraper">
                          <div class="text-block-25">Meeting Link</div>
                          <div class="div-block-26">
                            <div>
                              <div class="text-block-26">
                                <!--                                <a-->
                                <!--                                    style="width: 46%; word-wrap: break-word;"-->
                                <!--                                  class="meeting-link"-->
                                <!--                                  :href="singleClass.groupSessionMeetingLink"-->
                                <!--                                  target="_blank"-->
                                <!--                                >-->
                                <!--                                  {{ singleClass.groupSessionMeetingLink }}-->
                                <!--                                </a>-->
                                <div
                                  @click="
                                    goToClassMeeting(
                                      singleClass.groupSessionMeetingLink
                                    )
                                  "
                                  class="class-link"
                                >
                                  {{ singleClass.groupSessionMeetingLink }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--                      <div class="professional-name-wraper">-->
                        <!--                        <div class="text-block-25">Client’s TimeZone</div>-->
                        <!--                        <div class="div-block-26">-->
                        <!--                          <div>-->
                        <!--                            <div class="text-block-26">-->
                        <!--                              {{ kjoioiio }}-->
                        <!--                            </div>-->
                        <!--                          </div>-->
                        <!--                        </div>-->
                        <!--                      </div>-->
                        <div class="professional-name-wraper">
                          <div class="text-block-25">Description</div>
                          <div class="div-block-26">
                            <div>
                              <div class="text-block-26">
                                {{ singleClass.groupSessionDescription }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--                      <div class="professional-name-wraper">-->
                        <!--                        <div class="text-block-25">Your Message</div>-->
                        <!--                        <div class="div-block-26">-->
                        <!--                          <div>-->
                        <!--                            <p class="paragraph-2">-->
                        <!--                              {{ hvguyuui }}-->
                        <!--                            </p>-->
                        <!--                          </div>-->
                        <!--                        </div>-->
                        <!--                      </div>-->
                      </div>
                    </div>
                    <div class="div-block-27">
                      <div
                        data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e5"
                        class="button-4 outline w-button"
                        @click="openDetails(index)"
                        v-if="!upcomingOpen || isSelected !== index"
                      >
                        View details
                      </div>
                      <div
                        data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e5"
                        class="button-4 outline w-button"
                        @click="closeDetails(index)"
                        v-if="upcomingOpen && isSelected === index"
                      >
                        Hide details
                      </div>
                      <div
                        data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e5"
                        class="button-4 outline w-button"
                        @click="openShareClassModal(singleClass)"
                      >
                        Share Class
                      </div>
                      <!--                    <div-->
                      <!--                      data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e7"-->
                      <!--                      href=""-->
                      <!--                      class="button-4 cancel-copy w-button"-->
                      <!--                    >-->
                      <!--                      Reschedule-->
                      <!--                    </div>-->
                      <!--                  <div-->
                      <!--                      data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e9"-->
                      <!--                      class="button-4-copy outline w-button"-->
                      <!--                      @click="activateCancel(upcomingBooking.bookingId)"-->
                      <!--                  >-->
                      <!--                    Cancel-->
                      <!--                  </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-w-tab="Tab 3"
              v-if="past"
              :class="past ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
            >
              <div class="myclass-empty-state" v-if="pastClasses.length === 0">
                <div class="div-block-19">
                  <img
                    src="@/assets/timeslot-images/myclass.svg"
                    loading="lazy"
                    alt=""
                    class="image-6"
                  />
                  <div class="text-block-20">Nothing to show here</div>
                  <div class="text-block-21">
                    You do not have any past class
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  class="bookings-list-wrapper bookings"
                  v-for="(singleClass, index) in pastClasses"
                  :key="index"
                >
                  <div class="div-block-24-copy">
                    <div class="booking-heading">
                      <div class="text-block-24">
                        {{ singleClass.groupSessionTopic }}
                      </div>
                    </div>
                    <div class="div-block-22">
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/calendar.svg"
                          alt=""
                          class="image-7"
                        />
                        <div>
                          {{
                            new Date(
                              singleClass.groupSessionStartTime.slice(0, 10)
                            )
                              .toString()
                              .slice(0, 11)
                          }}
                        </div>
                      </div>
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/calendar.svg"
                          alt=""
                          class="image-8"
                        />
                        <div>
                          {{
                            formatHours(
                              new Date(singleClass.groupSessionStartTime)
                            )
                          }}:{{
                            formatMinutes(
                              new Date(singleClass.groupSessionStartTime)
                            )
                          }}
                          {{
                            formatTime(
                              new Date(singleClass.groupSessionStartTime)
                            )
                          }}
                          -
                          {{
                            formatHours(
                              new Date(singleClass.groupSessionEndTime)
                            )
                          }}:{{
                            formatMinutes(
                              new Date(singleClass.groupSessionEndTime)
                            )
                          }}
                          {{
                            formatTime(
                              new Date(singleClass.groupSessionEndTime)
                            )
                          }}
                        </div>
                      </div>
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/money.svg"
                          alt=""
                          class="image-9"
                        />
                        <div>${{ singleClass.groupSessionAmount }}</div>
                      </div>
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/Frame.svg"
                          alt=""
                          class="image-9"
                        />
                        <div>
                          {{ singleClass.groupSessionMaxAttendance }} learners
                        </div>
                      </div>
                    </div>
                    <div
                      class="div-block-25 margin-booking"
                      v-if="upcomingOpen && isSelected === index"
                    >
                      <div class="professional-detail-wrapper">
                        <div class="professional-name-wraper">
                          <div class="text-block-25">
                            No of students that registered:
                          </div>
                          <div class="div-block-26">
                            <div>
                              <!--                              <img-->
                              <!--                                width="45"-->
                              <!--                                loading="lazy"-->
                              <!--                                :src="-->
                              <!--                                  require('@/assets/timeslot-images/profileImg.svg')-->
                              <!--                                "-->
                              <!--                                alt=""-->
                              <!--                                class="image-10"-->
                              <!--                              />-->
                            </div>
                            <div>
                              <div class="text-block-26">
                                {{ singleClass.groupSessionCurrentAttendees }}
                                students
                              </div>
                              <div></div>
                            </div>
                          </div>
                        </div>
                        <!--                        <div class="professional-name-wraper">-->
                        <!--                          <div class="text-block-25">Meeting Link</div>-->
                        <!--                          <div class="div-block-26">-->
                        <!--                            <div>-->
                        <!--                              <div class="text-block-26">-->
                        <!--                                <a-->
                        <!--                                  class="meeting-link"-->
                        <!--                                  :href="singleClass.groupSessionMeetingLink"-->
                        <!--                                  target="_blank"-->
                        <!--                                >-->
                        <!--                                  {{ singleClass.groupSessionMeetingLink }}-->
                        <!--                                </a>-->
                        <!--                              </div>-->
                        <!--                            </div>-->
                        <!--                          </div>-->
                        <!--                        </div>-->
                        <!--                      <div class="professional-name-wraper">-->
                        <!--                        <div class="text-block-25">Client’s TimeZone</div>-->
                        <!--                        <div class="div-block-26">-->
                        <!--                          <div>-->
                        <!--                            <div class="text-block-26">-->
                        <!--                              {{ kjoioiio }}-->
                        <!--                            </div>-->
                        <!--                          </div>-->
                        <!--                        </div>-->
                        <!--                      </div>-->
                        <!--                      <div class="professional-name-wraper">-->
                        <!--                        <div class="text-block-25">Topic</div>-->
                        <!--                        <div class="div-block-26">-->
                        <!--                          <div>-->
                        <!--                            <div class="text-block-26">-->
                        <!--                              {{ singleClass. }}-->
                        <!--                            </div>-->
                        <!--                          </div>-->
                        <!--                        </div>-->
                        <!--                      </div>-->
                        <div class="professional-name-wraper">
                          <div class="text-block-25">Description</div>
                          <div class="div-block-26">
                            <div>
                              <p class="paragraph-2">
                                {{ singleClass.groupSessionDescription }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="div-block-27">
                      <div
                        data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e5"
                        class="button-4 outline w-button"
                        @click="openDetails(index)"
                        v-if="!upcomingOpen || isSelected !== index"
                      >
                        View details
                      </div>
                      <div
                        data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e5"
                        class="button-4 outline w-button"
                        @click="closeDetails(index)"
                        v-if="upcomingOpen && isSelected === index"
                      >
                        Hide details
                      </div>
                      <!--                    <div-->
                      <!--                      data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e7"-->
                      <!--                      href=""-->
                      <!--                      class="button-4 cancel-copy w-button"-->
                      <!--                    >-->
                      <!--                      Reschedule-->
                      <!--                    </div>-->
                      <!--                  <div-->
                      <!--                      data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e9"-->
                      <!--                      class="button-4-copy outline w-button"-->
                      <!--                      @click="activateCancel(upcomingBooking.bookingId)"-->
                      <!--                  >-->
                      <!--                    Cancel-->
                      <!--                  </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <UpdateTimezoneModal v-if="time" :cancel="closeTime" />
    <ShareClassModal
      v-if="shareClass"
      :cancel="closeShareClassModal"
      :link="generateClassLink"
    />
    <template v-slot:right-side-nav>
      <ProfRightSideMenu />
    </template>
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
import ProfRightSideMenu from "@/views/timeslot/ProfRightSideMenu";
import ProfessionalAppNavBar from "@/components/navbar/ProfessionalAppNavBar";
import ProfessionalSidebar from "@/views/timeslot/ProfessionalSidebar";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import { mapState } from "vuex";
import GroupSessionRequest from "@/model/requests/GroupSessionRequest";
import moment from "moment/moment";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
import UpdateTimezoneModal from "@/components/modal/UpdateTimezoneModal";
import ShareClassModal from "@/components/modal/ShareClassModal";
export default {
  name: "ProfessionalClasses",
  components: {
    BaseComponentLoader,
    ProfRightSideMenu,
    TimeslotDashboardLayout,
    UpdateTimezoneModal,
    ShareClassModal
  },
  data() {
    return {
      upcoming: true,
      past: false,
      bar: true,
      cross: false,
      isSelected: null,
      upcomingOpen: false,
      classModal: false,
      readModel: GroupSessionRequest.readByProfessionalId,
      time: false,
      filterType: "All",
      shareClass: false
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      customerToProfessionalId: state =>
        state.professional.customerToProfessionalId,
      profClasses: state => state.groupSession.profGroupSessions,
      customerInfo: state => state.customer.customerInfo,
      profClassesAlt: state => state.groupSession.groupSessionsAlt,
      currentClassId: state => state.groupSession.currentClassId,
      userClasses: state => state.groupSession.userGroupSessions,
      userClassesAlt: state => state.groupSession.userGroupSessionsAlt
    }),
    upcomingClasses() {
      return this.userClasses.filter(
        item => item.groupSessionStatus === "UPCOMING"
      );
    },
    pastClasses() {
      return this.userClasses.filter(
        item => item.groupSessionStatus === "PAST"
      );
    },
    // formattedClassLink(value){
    //   return `app.timeslate.com/class-details/${value}`;
    // },
    ...mapState(["loader"])
  },
  methods: {
    // generateClassLink() {
    //  this.formattedClassLink();
    // },
    openShareClassModal(value) {
      // console.log(value.groupSessionId);
      this.shareClass = true;
      StoreUtils.commit(
        "groupSession/updateCurrentClassId",
        value.groupSessionId
      );
    },
    generateClassLink() {
      return `app.timeslate.com/class-details/${this.currentClassId}`;
    },

    closeShareClassModal() {
      this.shareClass = false;
    },
    openUpcoming() {
      this.upcoming = true;
      this.past = false;
    },
    openPast() {
      this.upcoming = false;
      this.past = true;
    },
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    goToProfile() {
      RouterUtils.changeRouteUrlTo(`/professionals/${this.professionalId}`);
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    openDetails(index) {
      this.isSelected = index;
      this.upcomingOpen = true;
    },
    closeDetails(index) {
      this.isSelected = index;
      this.upcomingOpen = false;
    },
    closeClassModal() {
      this.classModal = false;
    },
    openClassModal() {
      RouterUtils.changeRouteUrlTo("/create-class");
    },
    formatTime(date) {
      return moment(date).format("a");
    },
    formatMinutes(date) {
      return moment(date).format("mm");
    },
    formatHours(date) {
      return moment(date).format("h");
    },
    logout() {
      StoreUtils.dispatch(StoreUtils.actions.auth.LOGOUT);
    },
    openTime() {
      this.time = true;
    },
    closeTime() {
      this.time = false;
    },
    goToClassDetails(value) {
      RouterUtils.changeRouteUrlTo(`/class-details/${value.groupSessionId}`);
    },
    goToClassMeeting(value) {
      window.open(value, "_blank");
    }
  },
  watch: {
    filterType(newValue) {
      if (newValue.toLowerCase() === "client") {
        StoreUtils.commit(
          "groupSession/updateUserGroupSessions",
          (this.userClasses = this.userClassesAlt.filter(
            item => item.type.toLowerCase() === "professional"
          ))
        );
      } else if (newValue.toLowerCase() === "personal") {
        StoreUtils.commit(
          "groupSession/updateUserGroupSessions",
          (this.userClasses = this.userClassesAlt.filter(
            item => item.type.toLowerCase() === "customer"
          ))
        );
      } else if (newValue.toLowerCase() === "all") {
        StoreUtils.commit(
          "groupSession/updateUserGroupSessions",
          (this.userClasses = this.userClassesAlt)
        );
      }
    }
  },
  mounted() {
    // if ("professional" in this.userInfo) {
    //   this.readModel.groupSessionProfessionalId = this.userInfo.professional.professionalId;
    // } else {
    //   this.readModel.groupSessionProfessionalId = this.customerToProfessionalId;
    // }
    // this.readModel.bookingProfessionalId = this.professionalInfo.professionalId;
    // StoreUtils.dispatch("groupSession/readByProfessionalId", this.readModel);
    StoreUtils.dispatch("groupSession/readUserGroupSessions");
  }
};
</script>

<style scoped>
.margin-booking {
  margin-top: 20px;
}
.filter-size {
  width: 15%;
  margin-right: 20px;
}
.text-block-24:hover {
  font-weight: 600;
}

.meeting-link {
  /*width: 70%;*/
  /*color: black;*/
  /*white-space: normal;*/
  /*white-space: break-spaces;*/
  /*overflow: visible;*/
  /*text-overflow: ellipsis;*/
}
.class-link {
  width: 46%;
  word-wrap: break-word;
  color: #007bff;
}
.class-link:hover {
  text-decoration: underline;
}

@media only screen and (max-width: 790px) {
  .filter-size {
    width: 35%;
    margin-right: 0;
  }
}
@media only screen and (min-width: 791px) and (max-width: 912px) {
  .filter-size {
    width: 20%;
    margin-right: 0;
  }
}
</style>
